module.exports = __webpack_public_path__ + "static/media/strawberry_jam.fe696b20.png";